export default __webpack_public_path__ + "images/dd7d62bfabce3d19ef530f0aa4cf1fd4-health.png";